import * as type from './type';
import util from 'common/js/util';

export default{
    [type.GET_HOT_SALES](context, option){
        util.post({
            params: {
                functionId: 'productHotsales'
            },
            sc(data){
                context.commit(type.SET_HOT_SALES, data.data);
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    [type.GET_DONGDONG_LINK](context, option){
        let self = this;
        util.post({
            params: {
                functionId: 'b2bDongDong',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/store/actions.js